/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M490.764 387.235c11.658 0 21.119 9.46 21.119 21.118 0 11.658-9.461 21.119-21.119 21.119H22.752c-11.657 0-21.118-9.461-21.118-21.119 0-11.657 9.46-21.118 21.118-21.118h468.012zm0-151.954c11.658 0 21.119 9.46 21.119 21.118 0 11.658-9.461 21.119-21.119 21.119H22.752c-11.657 0-21.118-9.461-21.118-21.119 0-11.657 9.46-21.118 21.118-21.118h468.012zm0-151.966c11.658 0 21.119 9.461 21.119 21.119 0 11.657-9.461 21.118-21.119 21.118H22.752c-11.657 0-21.118-9.46-21.118-21.118 0-11.658 9.46-21.119 21.118-21.119h468.012z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconMenu = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconMenu.defaultProps = {
  theme,
};
IconMenu.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconMenu.displayName = 'IconMenu';
export { IconMenu };
